import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { IssueTypes } from '@risksmart-app/trpc/src/services/service.types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

interface UpdateIssueTRPCInput {
  Id: string;
  Title: string;
  DateIdentified: string;
  DateOccurred: string;
  Type: IssueTypes;
  OriginalTimestamp: string;
  Details?: string | null;
  ImpactsCustomer?: boolean | null;
  IsExternalIssue?: boolean | null;
  CustomAttributeData?: CustomAttributeData | null;
  Meta?: Record<string, unknown> | null;
  OwnerUserIds?: string[];
  OwnerGroupIds?: string[];
  ContributorUserIds?: string[];
  ContributorGroupIds?: string[];
  ViewerUserIds?: string[] | null;
  ViewerGroupIds?: string[] | null;
  TagTypeIds?: string[];
  DepartmentTypeIds?: string[];
}

export const useUpdateIssueTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.issue.update.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.issue.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.issue.issueById.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.issue.issuesByParentId.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.issue.issueAssessmentByParentId.queryKey(),
        });
      },
    }),
  });

  return {
    updateIssue: async (variables: UpdateIssueTRPCInput): Promise<void> => {
      await mutation.mutateAsync(variables);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
